import { OnlineSales } from 'gw-edge-client';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { externalCasesAtom } from '../atoms/externalCasesAtom';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { startDateAtom } from '../atoms/startDateAtom';

export const useSaveAllEdi = (): {
    saveData: () => Promise<void>;
    isWaiting: boolean;
} => {
    const [isWaiting, setIsWaiting] = useState(false);
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const externalCasesDTO = useRecoilValue(externalCasesAtom);
    const startDatesDTO = useRecoilValue(startDateAtom);
    const updateDateDTO = { externalCasesDTO, startDatesDTO };

    const saveData = async (): Promise<void> => {
        try {
            setIsWaiting(true);
            await OnlineSales.saveAllDatesAndEdis(jobNumber, sessionId, {}, updateDateDTO);
            setIsWaiting(false);
        } catch (err) {
            setIsWaiting(false);
            if (err instanceof Error) throw err;
        }
    };

    return { saveData, isWaiting };
};
